function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194.595 0.0037545C196.698 -0.0635985 198.728 0.77791 200.166 2.31322C201.623 3.82374 202.415 5.85474 202.364 7.95292V7.99911C202.405 10.1036 201.609 12.1383 200.152 13.6573C198.676 15.1485 196.666 15.9895 194.568 15.9938C192.469 15.9982 190.456 15.1655 188.974 13.6804C187.526 12.1664 186.739 10.1396 186.785 8.0453V7.99911C186.744 5.89534 187.537 3.86095 188.992 2.34093C190.439 0.795369 192.479 -0.055606 194.595 0.0037545ZM198.198 11.8975C199.15 10.8387 199.657 9.4544 199.616 8.03144V7.99911C199.652 6.56475 199.14 5.17051 198.184 4.10074C197.269 3.0557 195.938 2.46898 194.549 2.49797C193.174 2.46027 191.853 3.03366 190.942 4.06379C189.995 5.12906 189.488 6.51425 189.524 7.93906V7.98525C189.488 9.4159 189.998 10.8065 190.951 11.8744C191.873 12.9147 193.206 13.496 194.595 13.4633C195.969 13.5035 197.29 12.9295 198.198 11.8975Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M171.949 13.588C170.259 15.1503 168.038 16.0107 165.736 15.9945C163.635 16.0761 161.6 15.2519 160.147 13.7312C158.71 12.1938 157.941 10.149 158.009 8.0453V7.99911C157.966 5.90154 158.749 3.87104 160.189 2.34555C161.597 0.804608 163.604 -0.049764 165.69 0.00375474C166.779 -0.0228228 167.863 0.154193 168.886 0.525693C169.814 0.903015 170.671 1.43738 171.417 2.10536L169.759 4.16079C169.21 3.64867 168.583 3.22625 167.902 2.90906C167.169 2.61531 166.383 2.47539 165.593 2.49797C164.264 2.4835 163 3.07303 162.157 4.10074C161.231 5.16894 160.736 6.54425 160.771 7.95754V7.99911C160.712 9.44967 161.207 10.8683 162.157 11.9668C163.088 13.0006 164.429 13.5703 165.819 13.5233C167.117 13.5531 168.387 13.1393 169.417 12.3501V9.45869H165.607V7.0938H171.949V13.588Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.5726 0.156179H32.1385L25.5888 15.7312H28.2678L29.8013 12.013H36.8498L38.3602 15.745H41.1315L34.5726 0.156179ZM30.7574 9.58802L33.3117 3.4079L35.889 9.58802H30.7574Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M66.2215 13.3016V15.7312H55.0668V0.267032H66.1153V2.69659H57.6857V6.71967H65.1591V9.14922H57.6857V13.3016H66.2215Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M83.9905 15.7312V4.68734L88.651 11.9298H88.7388L93.4408 4.64115V15.7312H96.0597V0.267032H93.2699L88.7388 7.57879L84.203 0.267032H81.4131V15.7312H83.9905Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M114.919 0.267032H112.3V15.7266H114.919V0.267032Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M133.736 15.7312V4.72891L141.949 15.7312H144.143V0.267032H141.565V10.9598L133.584 0.267032H131.159V15.7312H133.736Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.35024 2.14459C10.148 3.30016 10.327 4.77394 9.82907 6.08688H9.84754C12.0354 7.03577 13.2574 9.38949 12.7747 11.7249C12.292 14.0603 10.237 15.7367 7.85217 15.7404H0V0.299366H5.8337C7.23788 0.299204 8.5525 0.98902 9.35024 2.14459ZM5.85218 2.77511H2.61893L2.62817 9.01989C3.45505 7.9996 4.49984 7.17735 5.68589 6.61343L6.14779 6.42406C6.20828 6.3957 6.26878 6.36889 6.32865 6.34236C6.41502 6.30408 6.50013 6.26636 6.58197 6.22544C7.22696 5.93146 7.64689 5.29438 7.66279 4.58573C7.65774 3.58785 6.85005 2.78016 5.85218 2.77511ZM7.85217 13.2693H3.06235C3.67204 11.4217 4.90991 9.67578 6.70206 8.84899L7.11314 8.66423L7.15147 8.64783C7.30084 8.58396 7.45165 8.51947 7.57503 8.44715C7.75395 8.36097 7.92817 8.26538 8.09697 8.16077C9.43365 8.3193 10.4201 9.48464 10.3556 10.8291C10.2912 12.1736 9.19788 13.2393 7.85217 13.2693Z",
  fill: "white"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 16,
    viewBox: "0 0 203 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a869e592.svg";
export { ForwardRef as ReactComponent };